import {Injectable} from '@angular/core';
import {AuthService as Base} from "@shared/services/auth.service";

@Injectable({
  providedIn: 'root'
})
export class AuthService extends Base {
}
